import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { ICD10Disease } from '@dreryk/egabinet-icd-dictionary-frontend-api';

import { Bean, FieldControllerProps, ValidationRules } from '@dreryk/react-common';
import {
   Autosuggest,
   AutosuggestOnSelectionChange,
   FormLabel,
   useInteractiveTableContext,
} from '@dreryk/react-components';

import { interactiveTableKeys } from '../../translations';
import { DiagnosesTableBean } from '../table/DiagnosesInteractiveTable.types';

import { useDefaultItems } from './DiseaseSelector.hooks';
import { itemRenderer, searchCreator } from './DiseaseSelector.utils';

type DiseaseSelectorProps = FieldControllerProps<`${string}.selection`, ICD10Disease> & {
   readonly dictionaryValidOn: Date;
   readonly defaultItems?: ICD10Disease[];
   readonly onSelectionChange: AutosuggestOnSelectionChange<ICD10Disease>;
};

export const DiseaseSelector = (props: DiseaseSelectorProps): JSX.Element => {
   const { getValues } = useInteractiveTableContext<DiagnosesTableBean>();

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: props.required && isEmpty(getValues()),
      };
   }, [getValues, props.required]);

   return (
      <Autosuggest<ICD10Disease>
         testId={'disease'}
         controller={props.register(props.name, validationRules)}
         keyProperty={'code'}
         label={<FormLabel testId={'label'} label={interactiveTableKeys.autosuggest.label} required={props.required} />}
         placeholder={interactiveTableKeys.autosuggest.placeholder}
         horizontal={false}
         defaultValue={null}
         defaultItems={useDefaultItems(props.defaultItems)}
         searchCreator={searchCreator(props.dictionaryValidOn)}
         itemRenderer={itemRenderer}
         onSelectionChange={props.onSelectionChange}
         minChars={2}
         resetAfterSelection
      />
   );
};
